/**
 * Waits before retrying work that failed for lack of a connection: until the browser reports it is
 * back online, or, while it already reports online, at most `delayWhileOnlineMs`. A reconnection
 * during that delay retries at once.
 */
export function waitBeforeRetryingConnection(delayWhileOnlineMs: number): Promise<void> {
  return new Promise((resolve) => {
    const retry = () => {
      window.removeEventListener("online", retry);
      clearTimeout(delayTimer);
      resolve();
    };
    window.addEventListener("online", retry);
    const delayTimer = navigator.onLine === false ? undefined : setTimeout(retry, delayWhileOnlineMs);
  });
}
